import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const record7Api = {
    //查詢收到的名片收錄請求
    "getAdditionalrecord7List": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record7/getAdditionalrecord7List`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                group: null,
            }
        }
    },
    //上傳icon圖片
    "updaIconFile": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record7/updaIconFile`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                imgs: null   //base64 data
            }
        }
    },
    //添加通訊方式
    "addAdditionalrecord7": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record7/insertAdditionalrecord7`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                addinfo1: null,
                addinfo2: null,
                addinfo3: null,
                addinfo4: null,
                addremark1: null,
            }
        }
    },
    //修改通訊方式
    "updateAdditionalrecord7": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record7/insertAdditionalrecord7`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                companycode: null,
                addinfo1: null,
                addinfo2: null,
                addinfo3: null,
                addinfo4: null,
                addremark1: null,
            }
        }
    },
    //刪除通訊方式
    "deleteAdditionalrecord7": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record7/deleteAdditionalrecord7`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
            }
        }
    }
}

export default record7Api